
var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: false,
        showPlaceholderProductList: true,
		numberFilterTree: 2,
		filterTreeMobileStyle: 'style1',
        activeScrollToTop: true,
        styleScrollToTop: 'style1',
        collapseOnPCByDefault: true,
	},
};

(function() {
	BoostPFS.inject(this);
    boostPFSFilterConfig.general.limit = (Utils.isMobile()) ? 12 : boostPFSThemeConfig.custom.products_per_page;

	// Declare Templates
	var boostPFSTemplate = {
		// Grid Template
		'productGridItemHtml': '<div data-pfs-currency="[[itemId]]" class="Grid__Cell boost-pfs-product-item 1/'+ boostPFSThemeConfig.custom.mobile_row + '--phone 1/' + boostPFSThemeConfig.custom.tablet_row + '--tablet-and-up 1/' + boostPFSThemeConfig.custom.desktop_row + '--' + buildClass() +'">'+
									'<div class="ProductItem '+ buildClassHiz() +'">'+
										'<div class="ProductItem__Wrapper">'+
											'{{itemImages}}' +
											'{{itemLabels}}'+
											'{{itemInfo}}'+
										'</div>'+
										buildButtonSecond() +
									'</div>'+
								'</div>',

		// Pagination Template
		'previousActiveHtml': '<a class="Pagination__NavItem Link Link--primary" rel="prev" href="{{itemUrl}}"><svg class="{{ icon_class }}" role="presentation" viewBox="0 0 11 18"><path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></a>',
		'previousDisabledHtml': '',
		'nextActiveHtml': '<a class="Pagination__NavItem Link Link--primary" rel="next" href="{{itemUrl}}"><svg class="{{ icon_class }}" role="presentation" viewBox="0 0 11 18"><path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path> </svg></a>',
		'nextDisabledHtml': '',
		'pageItemHtml': '<a class="Pagination__NavItem Link Link--primary" href="{{itemUrl}}">{{itemTitle}}</a>',
		'pageItemSelectedHtml': '<span class="Pagination__NavItem is-active">{{itemTitle}}</span>',
		'pageItemRemainHtml': '<span class="Pagination__NavItem">{{itemTitle}}</span>',
		'paginateHtml': ' <div class="Pagination Text--subdued"><div class="Pagination__Nav">{{previous}}{{pageItems}}{{next}}</div></div>',
		// Sorting Template
		'sortingHtml': '{{sortingItems}}',
	};

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}
	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data, index) {
		if (!data) data = this.data;
		if (!index) index = this.index;
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';
		// Add Label
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImage(data, images));

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemInfo}}/g, buildInfo(data, index));

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildClass() {
		return boostPFSThemeConfig.custom.filter_position == 'drawer' ? 'lap-and-up' : 'desk';
	}

	function buildClassHiz() {
		return boostPFSThemeConfig.custom.use_horizontal ? 'ProductItem--horizontal' : '';
	}

	function buildButtonSecond() {
		return boostPFSThemeConfig.custom.use_horizontal ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' + boostPFSThemeConfig.label.view_product + '</a>' : '';
	}

  	/*
  	function buildImage(data, images) {
		var htmlImg = '';
		if (!images) images = [];
		if (images.length == 0){
			images.push({
				src: boostPFSConfig.general.no_image_url,
				id: data.id,
				width: 800,
				height: 800
			});
		}
		if (images.length > 0) {
			htmlImg += '<a href="{{itemUrl}}" class="ProductItem__ImageWrapper ';
			var use_natural_size = false;
			var has_alternate_image = false;
			if (boostPFSThemeConfig.custom.product_image_size == 'natural' || boostPFSThemeConfig.custom.use_horizontal) {
				use_natural_size = true;
			}
			if (boostPFSThemeConfig.custom.product_show_secondary_image && images.length > 1 && !boostPFSThemeConfig.custom.use_horizontal) {
				has_alternate_image = true;
			}
			if (has_alternate_image) {
				htmlImg += 'ProductItem__ImageWrapper--withAlternateImage';
			}
			htmlImg += '">';
			
			var max_width = images[0].width;
			if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
			var withCall = use_natural_size ? 'withFallback' : boostPFSThemeConfig.custom.product_image_size;
			htmlImg += '<div class="pfs-img-container AspectRatio AspectRatio--' + withCall + '" style="max-width: ' + max_width + 'px;';
			var aspect_ratio = images[0].width / images[0].height;
			if (use_natural_size) {
				htmlImg += 'padding-bottom: ' + (100 / aspect_ratio) + '%;';
			}
			htmlImg += ' --aspect-ratio: ' + aspect_ratio + '">';
			
			if (has_alternate_image && images.length > 1) {
				var sizes = '800,900,1000,1200';
				var support_size = imageSize(sizes, images[1]);
				//var thumbUrl = Utils.optimizeImage(images[1]['src'], '{width}x');
              	var thumbUrl = images[1]['src'];
				htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate" src="' + thumbUrl + '" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
			}
			
			var sizes_main = '800,900,1000,1200';
			var support_size = imageSize(sizes_main, images[0]);
			var thumbUrl_main = images.length > 0 ? images[0]['src'] : boostPFSConfig.general.no_image_url;
			htmlImg += '<img class="ProductItem__Image" src="' + thumbUrl_main + '" alt="' + data.title + '" data-image-id="' + images[0].id + '">';
			htmlImg += '<span class="Image__Loader"><img src="' + LoadedLogoUrl + '"></span>';
			htmlImg += '<noscript>';
			htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate" src="' + images[0]['src'] + '" alt="' + data.title + '">';
			htmlImg += '<img class="ProductItem__Image" src="' + images[0]['src'] + '" alt="' + data.title + '">';
			htmlImg += '</noscript>';
			htmlImg += '</div>';
			htmlImg += '</a>';
		}
		return htmlImg;
	}
  	*/
  
	function buildImage(data, images) {
		var htmlImg = '';
		if (!images) images = [];
		if (images.length == 0){
			images.push({
				src: boostPFSConfig.general.no_image_url,
				id: data.id,
				width: 600,
				height: 600
			});
		}
		if (images.length > 0) {
          	htmlImg += '<div class="product-image-slider">';
          	for (var i = 0; i < images.length; i++) {
              htmlImg += '<a href="{{itemUrl}}" class="ProductItem__ImageWrapper ';
              var use_natural_size = false;
              var has_alternate_image = false;
              if (boostPFSThemeConfig.custom.product_image_size == 'natural' || boostPFSThemeConfig.custom.use_horizontal) {
                  use_natural_size = true;
              }
              if (boostPFSThemeConfig.custom.product_show_secondary_image && images.length > 1 && !boostPFSThemeConfig.custom.use_horizontal) {
                  has_alternate_image = true;
              }
              if (has_alternate_image) {
  // 				htmlImg += 'ProductItem__ImageWrapper--withAlternateImage';
              }
              htmlImg += '">';
			
            
              var max_width = images[0].width;
              if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
              var withCall = use_natural_size ? 'withFallback' : boostPFSThemeConfig.custom.product_image_size;
              htmlImg += '<div class="pfs-img-container AspectRatio AspectRatio--' + withCall + '" style="max-width: ' + max_width + 'px;';
              var aspect_ratio = images[0].width / images[0].height;
              if (use_natural_size) {
                htmlImg += 'padding-bottom: ' + (100 / aspect_ratio) + '%;';
              }
              htmlImg += ' --aspect-ratio: ' + aspect_ratio + '">';

              // 			if (has_alternate_image && images.length > 1) {
              // 				var sizes = '200,400,600,700,800,900,1000,1200';
              // 				var support_size = imageSize(sizes, images[1]);
              // 				var thumbUrl = Utils.optimizeImage(images[1]['src'], '{width}x');
              // 				htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
              // 			}

              var sizes_main = '200,400,600,700,800,900,1000,1200';
              var support_size = imageSize(sizes_main, images[0]);
              var thumbUrl_main = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '500x') : boostPFSConfig.general.no_image_url;
              // 			htmlImg += '<img class="ProductItem__Image Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl_main + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[0].id + '">';

              /* Start - Boost 124718 */
//               htmlImg += '<div class="product-image-slider">'; 

              htmlImg += '<img class="ProductItem__Image Image--lazyLoad Image--fadeIn" data-src="' + Utils.optimizeImage(images[i]['src'], '500x') + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[i].id + '">';

//               htmlImg += '</div>';
              /* End - Boost 124718 */
              htmlImg += '<span class="Image__Loader"></span>';
              htmlImg += '<noscript>';
              htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate" src="' + Utils.optimizeImage(images[0]['src'], '500x') + '" alt="' + data.title + '">';
              htmlImg += '<img class="ProductItem__Image" src="' + Utils.optimizeImage(images[0]['src'], '500x') + '" alt="' + data.title + '">';
              htmlImg += '</noscript>';
              htmlImg += '</div>';

          	
              htmlImg += '</a>';
            }

          	htmlImg += '</div>';
		}
		return htmlImg;
	}
	
	function imageSize(sizes, image) {
        if (image) {
			var desired_sizes = sizes.split(',');
			var supported_sizes = '';
			for (var k = 0; k < desired_sizes.length; k++) {
				var size = desired_sizes[k];
				var size_as_int = size * 1;
				if (image.width < size_as_int) { break; }
				supported_sizes = supported_sizes + size + ',';
			}
			
			if (supported_sizes == '') supported_sizes = image.width;
			
			if(!jQ.isNumeric(supported_sizes)) {
				supported_sizes = supported_sizes.split(',').join(',');
				supported_sizes = supported_sizes.substring(0,supported_sizes.lastIndexOf(','));
			}
			return supported_sizes;
		} else {
			return '';
		}
	}

	function buildPrice(data) {
		var html = '';
		var show_price_on_hover = boostPFSThemeConfig.custom.product_show_price_on_hover;
		var classPriceHover = show_price_on_hover ? 'ProductItem__PriceList--showOnHover' : '';
		html += '<div class="ProductItem__PriceList '  + classPriceHover + ' Heading">';
		if (onSale) {
			html += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible>' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat, true) + '</span>';
			html += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>' + Utils.formatMoney(data.price_min, Globals.moneyFormat, true) + '</span> ';			
		} else {
			if (priceVaries) {
				html += '<span class="ProductItem__Price Price Text--subdued">' + boostPFSThemeConfig.label.from.replace(/{{min_price}}/g, Utils.formatMoney(data.price_min, Globals.moneyFormat, true)) + '</span>';
			} else {
				html += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(data.price_min, Globals.moneyFormat, true) + '</span>';
			}
		}
		html += '</div>';
		return html;
	}

	function buildLabels(data) {
		var html = '';
		var product_labels = '';
		// if (boostPFSThemeConfig.custom.show_labels) {
		// 	product_labels = '';
		// 	var tags = data.tags;
		// 	for (var k = 0; k < tags.length; k++) {
		// 		var tag = tags[k];
		// 		if (tag.indexOf('__label') != -1) {
		// 		product_labels += '<span class="ProductItem__Label Heading Text--subdued tag">' + tag.split('__label:')[1] + '</span>';
		// 		break;
		// 		}
		// 	}
		// 	if (!soldOut) {
		// 		if (onSale)
		// 			product_labels += '<span class="ProductItem__Label Heading Text--subdued on_sale">' + boostPFSThemeConfig.label.sale + '</span>';
		// 	} else {
		// 		product_labels += ' <span class="ProductItem__Label Heading Text--subdued sold_out">' + boostPFSThemeConfig.label.sold_out + '</span>';
		// 	}
			
		// 	if (product_labels != '') {
		// 		html += '<div class="ProductItem__LabelList">';
		// 		html += product_labels;
		// 		html += '</div>';
		// 	}
		// }
		return html;
	}

	function buildInfo(data, indx) {
		var html = '';
		if (boostPFSThemeConfig.custom.show_product_info) {
			var infoClass = (!boostPFSThemeConfig.custom.use_horizontal) ? 'ProductItem__Info--' + boostPFSThemeConfig.custom.product_info_alignment : '';
			var product_labels = '';
			if (boostPFSThemeConfig.custom.show_labels) {
				product_labels = '';
				var tags = data.tags;
				for (var k = 0; k < tags.length; k++) {
					var tag = tags[k];
					if (tag.indexOf('__label') != -1) {
					product_labels += '<span class="ProductItem__Label Heading Text--subdued tag">' + tag.split('__label:')[1] + '</span>';
					break;
					}
				}
				if (!soldOut) {
					if (onSale)
						product_labels += '<span class="ProductItem__Label Heading Text--subdued on_sale">' + boostPFSThemeConfig.label.sale + '</span>';
				} else {
					product_labels += ' <span class="ProductItem__Label Heading Text--subdued sold_out" >' + boostPFSThemeConfig.label.sold_out + '</span>';
				}
				
				if (product_labels != '') {
					html += '<div class="ProductItem__Info is_labels ' + infoClass + ' ">';
				}else{
					html += '<div class="ProductItem__Info is_notlabels ' + infoClass + ' ">';
				}
			}

			var product_labels = '';
			if (boostPFSThemeConfig.custom.show_labels) {
			if (!soldOut) {
				if (onSale)
					product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + boostPFSThemeConfig.label.sale + '</span>';
				} 
			}
			html += '<p class="ProductItem__Sale">' + product_labels + '</p>';
            html += '<div class="boost-pfs-wrapper-info">';
            html += '<div class="boost-pfs-left-info">';
			if (boostPFSThemeConfig.custom.show_vendor) {
				html += '<p class="ProductItem__Vendor Heading">' + data.vendor + '</p>';
			}

			html += '<h2 class="ProductItem__Title Heading">';
			html += '<a href="{{itemUrl}}">' + data.title + '</a>';
			html += '</h2>';        
			html += '{{itemReviews}}';
            html += '</div>';
            html += '<div class="boost-pfs-right-info">';
			html += buildPrice(data);
			if (boostPFSThemeConfig.custom.show_color_swatch) {
				html += buildSwatch(data, indx);	
			}
			html += '<button class="custom-heart-icon swym-button swym-add-to-wishlist-view-product product_'+ data.id + '" data-swaction="addToWishlist" data-product-id="'+ data.id + '"></button>';
    		html += '</div>';
            html += '</div>';
            html += '</div>';
        }

		return html;
	}

	function buildSwatch(data, indx) {
		var itemSwatchHtml = '';
		if (boostPFSThemeConfig.custom.show_color_swatch) {
		var color_name = boostPFSThemeConfig.custom.section_id + '-' + data.id + '-' + indx;
		data.options_with_values.forEach(function (option, index) {
			var option_name = option.name.toLowerCase();
			if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1 || option_name.indexOf('couleur') != -1) {
			var values = '';
			itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
			var i = 0;
			data.variants.forEach(function (variant) {
				var temp = variant.merged_options.filter(function (obj) {
					obj = obj.toLowerCase();
					if (obj.indexOf('color') != -1 || obj.indexOf('colour') != -1)
						return obj;
				});
				temp = temp[0].split(':');

				var value = temp[1].toLowerCase();
				if (values.indexOf(value) == -1) {
					values = values + ',' + value;
					values = values.split(',');
					var size = '200,400,600,700,800,900,1000,1200';
					var supported_sizes = imageSize(size, variant.image);
					var color_image = Utils.optimizeImage(variant.image);
					var name_color = Utils.slugify(value) + '.png';
					var checked = (i == 0) ? 'checked=checked' : '';
					var imageInfo = null;
					var image_aspect_ratio = 1;
					imageInfo = data.images_info.find(function (imageOb) {
						if (imageOb.src == variant.image){
							image_aspect_ratio = imageOb.width / imageOb.height;
						return imageOb;
						} 
					});
					if (!imageInfo){
						if (data.images_info.length > 0){
							imageInfo = data.images_info[0];
						} else {
							imageInfo = {
							src: boostPFSConfig.general.no_image_url,
								id: variant.id,
								width: 480,
								height: 480
							}
						}
						
					}
					var dataImg = (imageInfo != null) ? '" data-image-url="' + imageInfo.src + '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="1" data-image-id="' + imageInfo.id + '"' : '';
					var color_input_id = color_name + "-" + values.length;
					var variant_price = variant.price ? variant.price : 0;
					var variant_compare_at_price = variant.compare_at_price ? variant.compare_at_price : 0;
					var url_color = Utils.getFilePath(Utils.slugify(value), Globals.swatchExtension, Settings.getSettingValue('general.swatchImageVersion'));
					itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
					itemSwatchHtml += '<input class="ColorSwatch__Radio" type="radio" ' + checked + ' name="' + color_name + '" id="' + color_input_id + '" value="' + value + '" data-image-aspect-ratio="' + image_aspect_ratio + '" data-variant-price="' + variant_price + '" data-variant-compare-at-price="' + variant_compare_at_price + '" data-variant-url="' + Utils.buildProductItemUrl(data) + '?variant=' + variant.id + '#Image' +  imageInfo.id + '"' + dataImg + '  aria-hidden="true">';
					itemSwatchHtml += '<label class="ColorSwatch ColorSwatch--small" for="' + color_input_id + '" style="background-color: ' + value.replace(' ', '').toLowerCase() + '; background-image: url(' + url_color + ')" title="' + value + '" data-tooltip="' + value + '"></label>';
					itemSwatchHtml += '</div>';
					i++;
				}
			});
			itemSwatchHtml += '</div>';
			}
		});
		}
		return itemSwatchHtml;
	}
	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}
			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var classActive = (Globals.queryParams.sort == k) ? 'is-selected' : '';
					sortingItemsHtml += '<button class="Popover__Value ' + classActive + ' Heading Link Link--primary u-h6" data-value="' + k + '">' + sortingArr[k] + '</button>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		var topSortingSelector = jQ(Selector.topSorting);
		topSortingSelector.find('.Popover__Value').on('click', function(e) {
			FilterApi.setParam('sort', jQ(this).data('value'));
			FilterApi.applyFilter('sort');
			jQ('.CollectionToolbar__Item--sort').trigger('click');
		});
	}
	/************************** END BUILD TOOLBAR **************************/

    function buildCurrency(data) {
        var html = '';
        if (data.price_min < data.compare_at_price_min) {

            html += '<span class="boost-pfs-filter-product-item-sale-price">' + Utils.formatMoney(data.price_min / 100, Globals.moneyFormatWithCurrency) + '</span>';
            html += '<s>' + Utils.formatMoney(data.compare_at_price_min / 100, Globals.moneyFormatWithCurrency) + '</s> ';
        } else {
            if (data.price_min < data.price_max) {
                html += '<span class="boost-pfs-filter-product-item-price-from-text">' + (boostPFSThemeConfig.label_basic.from) + ' ' + '</span>';
            }
            html += '<span class="boost-pfs-filter-product-item-regular-price">' + Utils.formatMoney(data.price_min / 100, Globals.moneyFormatWithCurrency) + '</span>';
        }
        return html;
    }
  
	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
		/**
		 *  Call theme function 
		 *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
		 *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
		 *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;
		
		if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
		bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
		bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
		}  
		*/

		// Fix image not load on Instagram browser - initialize swatch image
		jQ(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").on('click', function() {
			jQ(this).parent().parent().find('label.ColorSwatch').removeClass('active');
			jQ(this).addClass('active');
			var parent = jQ(this).parent();
			var productImage = jQ(this).parent().parent().parent().parent().find('a.ProductItem__ImageWrapper');
			var variantInfo = parent.find('input.ColorSwatch__Radio');
			productImage.find('.AspectRatio .bc-sf-product-swatch-img').remove();
			productImage.find('.AspectRatio').prepend('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data('image-url') + '" />');
			productImage.find('img.ProductItem__Image').hide();
			productImage.attr('href', variantInfo.data('variant-url'));
			var variantPrice = '';
			if (variantInfo.data('variant-compare-at-price') > variantInfo.data('variant-price')){
				variantPrice += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>'
				variantPrice += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-compare-at-price')) + '</span>';
			} else {
				variantPrice += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>';
			}
			jQ(this).closest('.ProductItem__Wrapper').find('.ProductItem__PriceList').html(variantPrice);
		})
        if(window._swat){
          window._swat.initializeActionButtons(".boost-pfs-filter-products");
        }else{
          window.SwymCallbacks = window.SwymCallbacks || [];

          window.SwymCallbacks.push(function(){
            window._swat.initializeActionButtons(".boost-pfs-filter-products");
          });
        }

      // this.buildExtrasProductListByAjax(data, 'boost-multiple-currencies', function(results) {
      //     results.forEach(function(result,index) {
      //       if (Globals.queryParams.currency) {
      //         if(Globals.queryParams.currency.toLocaleLowerCase() !== Globals.defaultCurrency.toLocaleLowerCase() && data[index].price_min !== result.price_min / 100) {
      //         var element = '';
      //           element = jQ('[data-pfs-currency="' + result.id + '"] .boost-pfs-filter-product-item-price');
      //           element.html(buildCurrency(result));
      //         }
      //       }
      //     });
      //   });

      // Start Boost 211715
      var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
      var localeURLPart = "";
  
      if (hasShopifyRoutes) {
          localeURLPart = Shopify.routes.root.replace(/\/$/, '');
      } else if (elements.indexOf(boostPFSConfig.general.current_locale) > -1) {
          localeURLPart = "/" + boostPFSConfig.general.current_locale;
      }
      for (var i = 0; i < data.length; i++) {
        const prodId = data[i]['id'];
        quickUrl = localeURLPart + '/products/' + data[i].handle + '?view=boost-pfs-prod-prices';
        jQ.ajax({
            url: quickUrl,
            success: function(result) {
                console.log({result});
                jQ('[data-id="' + prodId + '"]').find('.ProductItem__PriceList').html(result.trim());
            }
        });
      }
      // End Boost 211715
	};

	// Build additional elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
      
      	
	};
  
  	Filter.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
      
        jQ(".boost-pfs-filter-scroll-to-top").css('display', 'none');
      
      	var product = data.products;
      
      	setTimeout(function(){
          for (var i = 0; i < product.length; i++) {
            var id = product[i].id;
            $('.Grid__Cell[data-id="' + id +'"] .product-image-slider').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              centerMode: true,
              focusOnSelect: true,
              infinite: true,
              fade: true,
              cssEase: 'linear',
              prevArrow: '<button type="button" class="prev-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
              nextArrow: '<button type="button" class="next-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    arrows: false,
                    dots: true
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    arrows: false,
                    dots: true
                  }
                }
              ]
            });
          }
        }, 500);
        
	};


  FilterScrollToTop.prototype.getTemplate = function () {
    return `
			<button aria-label="Back to top" class="boost-pfs-filter-scroll-to-top {{style}}" style="display: inline;">
               <svg version="1.1" id="FLECHA_xA0_Imagen_1_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            	 x="0px" y="0px" width="13px" height="70px" viewBox="0 0 13 70" enable-background="new 0 0 13 70" xml:space="preserve">
                  <image overflow="visible" width="13" height="70" id="FLECHA_xA0_Imagen" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAABGCAYAAAAXdB7TAAAACXBIWXMAAAsSAAALEgHS3X78AAAA
                  GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAKZJREFUeNpi/P//PwM2wMjIyAeU
                  +4RNjgmHBl0gdQVKYwKQTcgYCGSA+DFICkrLYKhB08AFxBehGmD4DEgcqyYgYAbijWgaYBgkzoxN
                  0zQcGmB4EoomIMgioAGGM0HqGYEMJyBeCXUeDLABMTcQfwXiX0jif4E4HCP0oDZHQU2OwiaPNZ4I
                  gVFNo5pGNY1qGtU0qmlU06imUU2jmkY1jWqihSaAAAMA+ZmUOGEA14kAAAAASUVORK5CYII=">
                  </image>
              </svg>
           </button>
	`.trim();
  }

  FilterApi.beforeCall = function() {  
     if(Globals.queryParams.sort != "price-descending" && Globals.queryParams.sort != "price-ascending") {
           Globals.queryParams.sort_first = 'extra_sort7';
         Globals.queryParams.sort_first_mode = 'asc'; 
     }
    //Start boost 197728
      if (Shopify.routes.root == '/en-uk/') {
        Globals.queryParams.h_options = ['brands'];
      }
     //End boost 197728
  }

  

	// Build Default layout
	Filter.prototype.errorFilterCallback = function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

    FilterOption.prototype.getTemplate = function() {
		switch (this.filterTreeType) {
			case 'vertical':
				return `
				<div class="{{class.filterOption}} {{blockTypeClass}} {{blockId}} {{class.filterScrollbar}} {{displayColumn}}">
					<div class="{{class.filterOptionTitle}}">
						<button aria-controls="{{ada.filterOptionDomId}}" aria-label="{{ada.filterOptionTitle}}" tabindex="0" class="{{class.button}} {{class.filterOptionTitle}}-heading">
							<span class="{{class.filterOptionTitle}}-text">
								{{blockTitle}}
								<span class="{{class.filterOptionTitle}}-count">
									{{numberAppliedFilterItems}}
								</span>
							</span>
							{{tooltip}}
						</button>
                        <svg class="boost-sd__filter-option-icon" xmlns="http://www.w3.org/2000/svg" width="7" height="12" role="img" viewBox="0 0 7 12" fill="none"><path class="boost-sd__filter-option-path" d="M6.58942 0.610713C6.26398 0.285274 5.73635 0.285274 5.41091 0.610713L0.611415 5.41021C0.455135 5.56649 0.366829 5.77895 0.366829 5.99996C0.366829 6.22098 0.454629 6.43294 0.610909 6.58922L5.41091 11.3892C5.73635 11.7147 6.26398 11.7147 6.58942 11.3892C6.91486 11.0638 6.91486 10.5362 6.58942 10.2107L2.37867 5.99996L6.58942 1.78922C6.91486 1.46379 6.91486 0.936153 6.58942 0.610713Z"></path></svg>
						<p class="boost-pfs-filter-selected-items-mobile"></p>
						{{clearButton}}
					</div>
					<div class="{{class.filterOptionContent}}">
						{{searchBox}}
						<div class="{{class.filterOptionContentInner}}">
							{{blockContent}}
						</div>
						{{viewMore}}
					</div>
				</div>
			`.trim();
			case 'horizontal':
				return `
				<div class="{{class.filterOption}} {{blockTypeClass}} {{blockId}} {{class.filterScrollbar}} {{displayColumn}}">
					<div class="{{class.filterOptionTitle}}">
						<button aria-controls="{{ada.filterOptionDomId}}" aria-label="{{ada.filterOptionTitle}}" tabindex="0" class="{{class.button}} {{class.filterOptionTitle}}-heading">
							<span class="{{class.filterOptionTitle}}-text">
							{{blockTitle}}
								<span class="{{class.filterOptionTitle}}-count">
									{{numberAppliedFilterItems}}
								</span>
							</span>
							{{tooltip}}
						</button>
					</div>
					<div class="{{class.filterOptionContent}}">
						<div class="{{class.filterOptionContentInner}}">
							{{blockContent}}
						</div>
						{{viewMore}}
						{{applyButton}}
						{{clearButton}}
					</div>
				</div>
			`.trim();
			default:
				console.warn('filterTreeType is wrong');
		}
	}

    //Start Boost 199897
    // Turn off convert currencies since Shopify return incorrect convert rate
    Utils.isConvertCurrenciesOnFrontEnd = () => {
    	var roundRules = Settings.getSettingValue('currencyRoundingRules');
    	return false;
    }

    Utils.convertPriceBasedOnPresentmentPrice = (productData) => {
    	var currenciesSeting = Settings.getSettingValue('general.currencies');
    	if (typeof currenciesSeting != 'undefined' && currenciesSeting.length > 1) {
    		var currentCurrency = Settings.getSettingValue('general.current_currency').toLowerCase().trim();
    		var prices = ['price_min', 'price_max', 'compare_at_price_min', 'compare_at_price_max'];
    		prices.forEach((priceKey) => {
    			var currentPriceKey = priceKey + '_' + currentCurrency;
    			if (typeof productData[currentPriceKey] != 'undefined') {
    				productData[priceKey] = productData[currentPriceKey];
    			}
    		});
    	}
    }
    //End Boost 199897
})();

// 	boost-custom-start
// 	#boost-100753: Change label for specific filter option item
var originalBuildLabelFn = FilterOptionItem.prototype.buildLabel;
FilterOptionItem.prototype.buildLabel = function(event) {
  // Call the original function first
  var label = originalBuildLabelFn.call(this, event);
  // Your code here
  if (label === "One Size") {
    label = "One size";
  }
  return label;
}
// 	boost-custom-end